import { render } from "./dialog-edit.vue?vue&type=template&id=ffe4208a&ts=true"
import script from "./dialog-edit.vue?vue&type=script&lang=ts"
export * from "./dialog-edit.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\work\\pc-customer-admin\\node_modules\\.pnpm\\vue-loader@16.8.3_@vue+comp_8f6e2ea806ee27baec234857288b09f4\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__